import {getComponent} from "../jsbase/utils";

export default {
    args: 'target',
    currentPage: 1,
    filteredListEl: null,

    props: {
        target: String,
        filteredList: String,
        currentPage: Number,
        lastPage: Number,
        itemsPerPage: Number,
    },

    data: {
        url: null,
        target: null,
        infoEl: null,
        nextBtn: null,
        prevBtn: null,
    },

    connect() {
        if (this.target) {
            this.data.targetEl = document.getElementById(this.target);
        }
        this.data.nextBtn = this.el.querySelector('[data-next]');
        this.data.prevBtn = this.el.querySelector('[data-prev]');
        this.data.infoEl = this.el.querySelector('[data-info]');
        this.currentPage = 1;

        if (this.load) {
            this.goToPage(1);
        }
    },

    events: [{
        name: 'click',
        selector: '[data-next]',
        handler(ev) {
            this.goNext();
        }
    }, {
        name: 'click',
        selector: '[data-prev]',
        handler(ev) {
            this.goPrevious();
        }
    }],

    methods: {
        getFilteredList() {
            if (this.filteredList && !this.filteredListEl) {
                this.filteredListEl = getComponent(this.filteredList, 'filtered-list');
            }
            return this.filteredListEl;
        },

        goNext() {
            if (this.currentPage < this.lastPage) {
                this.currentPage += 1;
                this.goToPage(this.currentPage);
            } else {

            }
        },

        goPrevious() {
            if (this.currentPage > 1) {
                this.currentPage -= 1;
                this.goToPage(this.currentPage);
            }
        },

        getPagingFilter() {
            return {
                paging: (this.currentPage - 1) * (this.itemsPerPage || 1),
                Limit: this.itemsPerPage || 10,
            };
        },

        update(data) {
            this.lastPage = data.pagingInfo.TotalPages;
            this.itemsPerPage = data.pagingInfo.EntriesPerPage;

            if (this.data.infoEl) {
                this.data.infoEl.innerHTML = `Total: ${data.pagingInfo.TotalEntries||0}, Seite ${this.currentPage}/${this.lastPage}`;
            }

            if (this.currentPage <= 1) {
                this.data.prevBtn.setAttribute('disabled', 'disabled');
            } else {
                this.data.prevBtn.removeAttribute('disabled');
            }
            if (this.currentPage >= this.lastPage) {
                this.data.nextBtn.setAttribute('disabled', 'disabled');
            } else {
                this.data.nextBtn.removeAttribute('disabled');
            }
        },

        goToPage(page) {
            if (this.getFilteredList()) {
                this.getFilteredList().load();
                return;
            }
            //
            let data = this.getPagingFilter();
            connection.getJson(this.url, {
                data: data,
            }).done(data => {
                this.lastPage = data.pagingInfo.TotalPages;
                this.itemsPerPage = data.pagingInfo.EntriesPerPage;
                this.data.targetEl.innerHTML = data.content;
                if (this.data.infoEl) {
                    this.data.infoEl.innerHTML = `Total: ${data.pagingInfo.TotalEntries||0}, Seite ${this.currentPage}/${this.lastPage}`;
                    onContentReady($(this.data.infoEl));
                }

                if (this.currentPage <= 1) {
                    this.data.prevBtn.setAttribute('disabled', 'disabled');
                } else {
                    this.data.prevBtn.removeAttribute('disabled');
                }
                if (this.currentPage >= this.lastPage) {
                    this.data.nextBtn.setAttribute('disabled', 'disabled');
                } else {
                    this.data.nextBtn.removeAttribute('disabled');
                }
            });
        },
    }

}
